import { render, staticRenderFns } from "./SystemEmailSend.vue?vue&type=template&id=2da0fa81&scoped=true"
import script from "./SystemEmailSend.vue?vue&type=script&lang=js"
export * from "./SystemEmailSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da0fa81",
  null
  
)

export default component.exports